import { HttpService } from 'core/modules/network-service';
import { get, head, isEmpty } from 'lodash';

// local dependencies
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc DrugPricingDrugDetail defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { DrugPricingDrugDetailService } from 'services/drugPricingDrugDetail';
 *
 * // create service instance and send/cancel request
 * const drugPricingDrugDetailService = new DrugPricingDrugDetailService();
 * const result = await drugPricingDrugDetailService.fetchData( '<user-id>' ); // fetch data
 * drugPricingDrugDetailService.cancel(); // cancel an active request
 */
export class DrugPricingDrugDetailService extends HttpService {

    // make request and fetch component data
    async fetchComponentData( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    isDataEmpty: isEmpty( get( response, 'body.component.data.state' ) ),
                    drugNdc: get( response, 'body.component.data.state.drugNdc', '' ),
                    drugName: get( response, 'body.component.data.state.drugName', '' ),
                    drugDescription: get( response, 'body.component.data.state.drugDescription', '' ),
                    filterValues: get( response, 'body.component.data.state.filters', '' ),
                    options: get( response, 'body.component.data.options.medicineVersion', [] ),
                    widgetTitle: get( response, 'body.component.structure.widgetConfig.title', {} ),
                    filters: get( response, 'body.component.structure.fields', [] ),
                    applyFilterAction: head( get( response, 'body.component.structure.actions', [] ) ),
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
